<template>
  <div>
    <div class="main-ct">
      <div>
        <p class="section-title">
          {{ $t('Gamification_GamesToPurchase_Title') }}
        </p>
        <p class="section-description">
          {{ $t('Gamification_GamesToPurchase_Description') }}
        </p>
      </div>
      <div class="game-card-ct">
        <game-card
          v-for="game in coreGames"
          :key="game.id"
          icon="gameshub-lock"
          :status="$t('Gamification_GamesToPurchase_Status')"
          :game="game"
          card-type="inactive"
          @click.native="showPurchasePopup(game)"
        />
      </div>
    </div>
    <game-pop-up
      v-if="selectedGameToPurchase"
      :game="selectedGameToPurchase"
      @close="closePurchasePopup"
    />
  </div>
</template>

<script>
import GameCard from '@/modules/gamification/components/games-hub-dashboard/GameCard.vue'
import GamePopUp from '@/modules/gamification/components/games-hub-dashboard/GamePopUp.vue'

export default {
  name: 'GamesToPurchase',
  components: { GamePopUp, GameCard },
  props: {
    coreGames: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedGameToPurchase: null,
      pulseClass: false
    }
  },
  methods: {
    showPurchasePopup(game) {
      this.selectedGameToPurchase = game
    },
    closePurchasePopup() {
      this.selectedGameToPurchase = null
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.game-card-ct {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #4b515f;
}

.section-description {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #5c6374;
}

>>> .gameshub-lock-icon {
  color: #7e8596;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/GamesToPurchase.vue